export default __webpack_public_path__ + "static/media/Layer_8@2x.21fcac1b.png";